/**
 * Design System - Components Index
 *
 * DS-5 (ADR-0028 dec. 6): los toggles propios (`ThemeToggle` / `ThemeSwitcher`)
 * fueron RETIRADOS. El único control de tema es `ThemeControl`, que renderiza el
 * `theme-switcher` de familia (`@/components/brand/theme-switcher`) en modo
 * controlado, cableado al `ThemeContext`.
 */

export { ThemeControl } from './ThemeControl';
